import { NOT_LOGGED_IN_USER_ID } from '../constants';
import { isValidProperty } from './isValidProperty';
import type { AppDataConfiguration } from '~/models';

export function parseSpaConfig<T extends keyof AppDataConfiguration>(
  config: string,
  requiredProperties: T[] = [],
) {
  if (!config) {
    throw new Error('No config provided!');
  }

  const parsedConfig = JSON.parse(config) as Partial<AppDataConfiguration> &
    Required<Pick<AppDataConfiguration, T>>;

  requiredProperties.forEach((prop) => {
    if (!isValidProperty(parsedConfig, String(prop))) {
      throw new Error(`Missing ${String(prop)} config property!`);
    }
  });

  return {
    customerId: NOT_LOGGED_IN_USER_ID,
    ...parsedConfig,
  };
}
